import { Template } from '@components';

export const Categories = () => {
    return (
        <Template.Categories origin='filters' />
    );
};
